export default __webpack_public_path__ + "static/media/NOULT.03902463.png";